// src/components/Inputs/RadioInputs.jsx

'use client';

import { memo } from 'react';
import { capitalize } from '@/lib/functions.utils';
import { Radio, FormControl, FormControlLabel, RadioGroup, FormLabel } from '@mui/material';
import { useFilters } from '@/contexts/Filters.context';


const RadioInputs = ({ codeSetData, filterName, icon, legend, lang = 'en' }) => {

  const { getFilterValue, updateFilterValue, hasFilter } = useFilters();

  const selectedRadio = getFilterValue(filterName);

  const handleRadioClick = (event) => {
    const value = event.currentTarget.value;
    // If clicking the already selected radio, clear it (toggle behavior)
    if (value === selectedRadio && value !== '') {
      updateFilterValue(filterName, '');
    } else {
      updateFilterValue(filterName, value);
    }
  };

  const isRadioSelected = (value) => selectedRadio === value;

  const labelStyle = {
    color: hasFilter(filterName) ? '#1976D2' : '',
  };

  return (
    <FormControl component={'fieldset'}>
      <FormLabel component={'legend'} style={labelStyle}>{icon}{legend}</FormLabel>
      <RadioGroup
        aria-label={legend}
        name={filterName}
        value={selectedRadio}
        onChange={handleRadioClick}
        sx={{
          '@media (pointer: fine)': {
            my: 0,
            '& .MuiRadio-root': {
              padding: '4px',
            },
          },
        }}
      >
        <FormControlLabel value={''} control={<Radio />} label={'Any'} checked={isRadioSelected('')} />
        {Object.entries(codeSetData).map(([key, data]) => (
          <FormControlLabel
            key={key}
            value={data.en}
            control={<Radio />}
            label={capitalize(data[lang])}
            checked={isRadioSelected(data.en)}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default memo(RadioInputs);
